<div class="container-fluid py-4">


    <!-- Loading Overlay -->
    <div *ngIf="isLoadingAction"
        class="position-fixed top-0 start-0 w-100 h-100 bg-dark opacity-50 d-flex justify-content-center align-items-center"
        style="z-index: 1050;">
        <div class="spinner-border text-light" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
    </div>


    <div class="d-flex justify-content-between align-items-center mb-3">
        <h2>Manage Organization Intents</h2>
    </div>


    <div class="mb-3">
        <label for="organization" class="form-label">Select Organization</label>
        <select id="organization" class="form-select" [(ngModel)]="selectedOrganizationId"
            (ngModelChange)="loadIntents()">
            <option value="" disabled>Select an organization</option>
            <option *ngFor="let org of organizations" [value]="org.id">{{ org.name }}</option>
        </select>
    </div>

    <div class="d-flex justify-content-between align-items-center mb-3">
        <input type="text" class="form-control me-2" placeholder="Search Intents..." [(ngModel)]="searchQuery"
            (input)="filterIntents()" />
        <button class="btn btn-outline-secondary" (click)="clearSearch()">Clear</button>
    </div>

    <div class="dropdown mb-3">
        <button class="btn btn-outline-primary dropdown-toggle" type="button" data-bs-toggle="dropdown"
            aria-expanded="false">
            Filter by Group: {{ selectedGroup || 'All' }}
        </button>
        <ul class="dropdown-menu">
            <li><button class="dropdown-item" (click)="selectGroup(null)">All</button></li>
            <li *ngFor="let group of groups">
                <button class="dropdown-item" (click)="selectGroup(group.value)">{{ group.value }}</button>
            </li>
        </ul>
    </div>

    <div class="d-flex justify-content-end align-items-center mb-3" *ngIf="hasSelectedIntents()">
        <button class="btn btn-primary btn-sm" (click)="openBulkToggleModal(bulkToggleModal)">
            Toggle Selected ({{ getSelectedIntentsCount() }})
        </button>
    </div>

    <div class="card shadow-sm">
        <div class="card-header bg-primary text-white">
            <h5 class="mb-0">Intent List</h5>
        </div>
        <div class="card-body p-0">
            <ag-grid-angular class="ag-theme-alpine" style="height: 600px; width: 100%;" [pagination]="true"
                [gridOptions]="gridOptions" [loading]="isLoadingIntents" (gridReady)="onGridReady($event)"
                [rowData]="filteredIntents" [rowSelection]="rowSelection" [modules]="modules" (selectionChanged)="onSelectionChanged()">
            </ag-grid-angular>
        </div>
    </div>

    <!-- Toggle Confirmation Modal -->
    <ng-template #toggleConfirmModal let-modal>
        <div class="modal-header">
            <h5 class="modal-title">{{ selectedIntent?.isIncluded ? 'Exclude' : 'Include' }} Intent</h5>
            <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
        </div>
        <div class="modal-body">
            <p class="text-wrap text-break">Are you sure you want to {{ selectedIntent?.isIncluded ? 'exclude' : 'include' }} the intent "{{ selectedIntent?.description }}"?</p>
            <p class="text-muted small">This will affect its availability for the selected organization.</p>
              </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Cancel</button>
            <button type="button" class="btn btn-primary" (click)="confirmToggleIntent(modal)">Confirm</button>
        </div>
    </ng-template>

  <!-- Bulk Toggle Confirmation Modal -->
  <ng-template #bulkToggleModal let-modal>
    <div class="modal-header">
        <h5 class="modal-title">Toggle Selected Intents</h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body">
        <p>You are about to toggle <strong>{{ getSelectedIntentsCount() }}</strong> intents.</p>
        <div class="mb-3">
            <label for="bulkToggleAction" class="form-label">Action</label>
            <select id="bulkToggleAction" [(ngModel)]="bulkToggleAction" class="form-select">
                <option value="include">Include</option>
                <option value="exclude">Exclude</option>
            </select>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="modal.dismiss('cancel click')">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="confirmBulkToggle(modal)">Confirm</button>
    </div>
</ng-template>    
</div>